// extracted by css-extract-rspack-plugin
export default {"heading":"f1ns_DB5r2sOZEbY","list":"AovhgZPSq2EKX7q4"};